// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      task_daily_checkin_title: 'Daily Check-in',
      task_daily_checkin_desc: 'Log in to the app daily to claim your reward',
      task_first_trade_title: 'First Trade of the Day',
      task_first_trade_desc: 'Place your first trade prediction today',
      task_active_trader_title: 'Active Trader (5 Trades)',
      task_active_trader_desc: 'Complete 5 trades in a single day',
      task_trading_master_title: 'Trading Master (10 Trades)',
      task_trading_master_desc: 'Complete 10 trades in a single day',
      task_coin_explorer_title: 'Coin Round Explorer',
      task_coin_explorer_desc: 'Participate in 3 coin-currency rounds',
      task_daily_victor_title: 'Daily Victor',
      task_daily_victor_desc: 'Win 2 trading rounds today',
      task_weekly_volume_title: 'Weekly Volume (50 Trades)',
      task_weekly_volume_desc: 'Complete 50 trades within a week',
      task_streak_builder_title: 'Streak Builder (3 Streak)',
      task_streak_builder_desc: 'Reach a winning streak of 3 in a week',
      task_asset_explorer_title: 'Asset Explorer',
      task_asset_explorer_desc: 'Trade across 3 different asset markets this week',
      task_high_roller_title: 'High Roller',
      task_high_roller_desc: 'Place 5 high-value trades this week',
      task_monthly_volume_title: 'Monthly Volume (200 Trades)',
      task_monthly_volume_desc: 'Complete 200 trades within a month',
      task_monthly_champion_title: 'Monthly Champion (20 Wins)',
      task_monthly_champion_desc: 'Win 20 trading rounds this month',
      task_monthly_referral_title: 'Monthly Referral Challenge',
      task_monthly_referral_desc: 'Invite 5 new friends this month',
      task_dedicated_trader_title: 'Dedicated Trader (15 Days)',
      task_dedicated_trader_desc: 'Trade on 15 different days this month',
      task_first_victory_title: 'First Victory',
      task_first_victory_desc: 'Win your very first trading round',
      task_first_friend_title: 'First Friend Invited',
      task_first_friend_desc: 'Invite 1 friend using your referral link',
      task_squad_builder_title: 'Squad Builder (5 Friends)',
      task_squad_builder_desc: 'Successfully invite 5 friends',
      task_network_master_title: 'Network Master (20 Friends)',
      task_network_master_desc: 'Successfully invite 20 friends',
      task_hot_streak_title: 'Hot Streak (5 Wins)',
      task_hot_streak_desc: 'Achieve a consecutive 5-win streak',
      task_unstoppable_title: 'Unstoppable (10 Wins)',
      task_unstoppable_desc: 'Achieve an epic 10-win streak',
      task_centurion_title: 'Centurion (100 Trades)',
      task_centurion_desc: 'Reach 100 total trades completed',
      task_join_telegram_title: 'Join Telegram Channel',
      task_join_telegram_desc: 'Subscribe to our official Telegram channel',
      task_follow_x_title: 'Follow on X (Twitter)',
      task_follow_x_desc: 'Follow our official X (Twitter) account',

      up: '▲ Up',
      down: '▼ Down',
      startDuel: 'Start duel',
      processing: 'Processing...',
      locked: 'Locked',
      insufficientBalance: 'Insufficient Balance',
      amount: 'Amount (USDT)',
      balance: 'Balance',
      wins: 'wins',
      streak: 'Streak',
      target: 'Target',
      frozen: 'FROZEN',
      locked30s: '30s LOCKED',
      waiting: 'Waiting to start',
      guessText: 'Guess if the price stays above Target',
      trade: 'Trade',
      profile: 'Profile',
      referral: 'Referral',
      deposit: 'Deposit',
      withdraw: 'Withdraw',
      wallet: 'Connect Wallet',
      walletAddress: 'Wallet Address',
      disconnect: 'Disconnect',
      depositDesc: 'Transfer TON / USDT to your account address',
      amountToDeposit: 'Amount (USDT / TON)',
      sendTransaction: 'Pay via TON Wallet',
      refDesc: 'Invite friends and earn 30% of our fee revenue on every trade they place!',
      yourCode: 'Your Code',
      copy: 'Copy',
      copied: 'Copied',
      selected: 'Selected',
      pool: 'Pool',
      share: 'Share',
      shareMessage: 'Join CandleDuel and compete in crypto price predictions! 🚀',

      youWon: 'You Won!',
      roundsResult: 'Rounds Result',
      multiDuelsSummary: 'Finished {{count}} simultaneous duels ({{wins}} wins)',
      singleDuelSummary: '{{symbol}} • {{position}}',
      netProfitLoss: 'Total Net P&L',
      entryPrice: 'Entry Price',
      closePrice: 'Close Price',
      continue: 'Continue',

      inviteTitle: 'Exclusive Invite Code',
      inviteDesc: 'Access to the prediction system is only possible with an invite code. Please enter your code.',
      invitePlaceholder: 'e.g. REF1234',
      enterApp: 'Enter App',

      errSelectDirection: 'Please select a direction (Up or Down).',
      errInvalidAmount: 'Bet amount must be greater than zero.',
      errLowBalance: 'Insufficient account balance!',
      errRoundFrozen: 'The round is frozen for the last 30 seconds.',
      errNoRound: 'No active round found for this symbol.',
      errBetFailed: 'Bet placement failed',
      betSuccess: 'Transaction executed successfully!',
      errProfileFetch: 'Error fetching user profile',
      errNoActiveRound: 'No active round found for {{symbol}}',
      errUserNotFound: 'User details not found. Please log in again.',

      tasksAndRewards: 'Tasks & Rewards',
      completeTasksDescription: 'Complete tasks to earn extra COINs!',
      daily: 'Daily',
      weekly: 'Weekly',
      monthly: 'Monthly',
      oneTime: 'One-Time',
      loading: 'Loading tasks...',
      noTasksAvailable: 'No tasks available in this section.',
      progress: 'Progress',
      claimed: 'Claimed',
      claim: 'Claim',
      inProgress: 'In Progress',
    },
  },
  tr: {
    translation: {
      task_daily_checkin_title: 'Günlük Giriş',
      task_daily_checkin_desc: 'Ödülünüzü almak için her gün uygulamaya giriş yapın',
      task_first_trade_title: 'Günün İlk İşlemi',
      task_first_trade_desc: 'Bugün ilk işlem tahmininizi yapın',
      task_active_trader_title: 'Aktif Tüccar (5 İşlem)',
      task_active_trader_desc: 'Tek bir günde 5 işlem tamamlayın',
      task_trading_master_title: 'Ticaret Ustası (10 İşlem)',
      task_trading_master_desc: 'Tek bir günde 10 işlem tamamlayın',
      task_coin_explorer_title: 'Kripto Turu Kaşifi',
      task_coin_explorer_desc: '3 kripto para turuna katılın',
      task_daily_victor_title: 'Günlük Galip',
      task_daily_victor_desc: 'Bugün 2 işlem turu kazanın',
      task_weekly_volume_title: 'Haftalık Hacim (50 İşlem)',
      task_weekly_volume_desc: 'Bir hafta içinde 50 işlem tamamlayın',
      task_streak_builder_title: 'Galibiyet Serisi (3 Seri)',
      task_streak_builder_desc: 'Bir haftada 3 üst üste galibiyete ulaşın',
      task_asset_explorer_title: 'Piyasa Kaşifi',
      task_asset_explorer_desc: 'Bu hafta 3 farklı varlık piyasasında işlem yapın',
      task_high_roller_title: 'Büyük Oynayan',
      task_high_roller_desc: 'Bu hafta 5 yüksek değerli işlem yapın',
      task_monthly_volume_title: 'Aylık Hacim (200 İşlem)',
      task_monthly_volume_desc: 'Bir ay içinde 200 işlem tamamlayın',
      task_monthly_champion_title: 'Aylık Şampiyon (20 Galibiyet)',
      task_monthly_champion_desc: 'Bu ay 20 işlem turu kazanın',
      task_monthly_referral_title: 'Aylık Davet Mücadelesi',
      task_monthly_referral_desc: 'Bu ay 5 yeni arkadaş davet edin',
      task_dedicated_trader_title: 'Sadık Tüccar (15 Gün)',
      task_dedicated_trader_desc: 'Bu ay 15 farklı günde işlem yapın',
      task_first_victory_title: 'İlk Zafer',
      task_first_victory_desc: 'İlk işlem turunuzu kazanın',
      task_first_friend_title: 'Davet Edilen İlk Arkadaş',
      task_first_friend_desc: 'Davet bağlantınızı kullanarak 1 arkadaşınızı davet edin',
      task_squad_builder_title: 'Takım Kurucu (5 Arkadaş)',
      task_squad_builder_desc: 'Başarıyla 5 arkadaşınızı davet edin',
      task_network_master_title: 'Ağ Ustası (20 Arkadaş)',
      task_network_master_desc: 'Başarıyla 20 arkadaşınızı davet edin',
      task_hot_streak_title: 'Sıcak Seri (5 Galibiyet)',
      task_hot_streak_desc: 'Üst üste 5 galibiyet serisi elde edin',
      task_unstoppable_title: 'Durdurulamaz (10 Galibiyet)',
      task_unstoppable_desc: 'Efsanevi 10 galibiyet serisine ulaşın',
      task_centurion_title: 'Yüzbaşı (100 İşlem)',
      task_centurion_desc: 'Toplamda 100 tamamlanmış işleme ulaşın',
      task_join_telegram_title: 'Telegram Kanalına Katıl',
      task_join_telegram_desc: 'Resmi Telegram kanalımıza abone olun',
      task_follow_x_title: 'X (Twitter) Bizi Takip Et',
      task_follow_x_desc: 'Resmi X (Twitter) hesabımızı takip edin',

      up: '▲ Yukarı',
      down: '▼ Aşağı',
      startDuel: 'Düelloyu Başlat',
      processing: 'İşleniyor...',
      locked: 'Kilitli',
      insufficientBalance: 'Yetersiz Bakiye',
      amount: 'Miktar (USDT)',
      balance: 'Bakiye',
      wins: 'galibiyet',
      streak: 'Seri',
      target: 'Hedef Fiyat',
      frozen: 'DONDURULDU',
      locked30s: '30s KİLİTLİ',
      waiting: 'Başlama bekleniyor',
      guessText: 'Fiyatın Hedefin üzerinde kalıp kalmayacağını tahmin edin',
      trade: 'Takas',
      profile: 'Profil',
      referral: 'Referans',
      deposit: 'Yatır',
      withdraw: 'Çek',
      wallet: 'Cüzdanı Bağla',
      walletAddress: 'Cüzdan Adresi',
      disconnect: 'Bağlantıyı Kes',
      depositDesc: 'Hesap adresinize TON / USDT transfer edin',
      amountToDeposit: 'Yatırılacak Miktar (USDT / TON)',
      sendTransaction: 'TON Cüzdanı ile Öde',
      refDesc: 'Arkadaşlarınızı davet edin ve yaptıkları her işlemden işlem ücretimizin %30\'ini kazanın!',
      yourCode: 'Kodunuz',
      copy: 'Kopyala',
      copied: 'Kopyalandı',
      selected: 'Seçildi',
      pool: 'Havuz',
      share: 'Paylaş',
      shareMessage: 'CandleDuel\'e katılın ve kripto fiyat tahminlerinde yarışın! 🚀',

      youWon: 'Kazandınız!',
      roundsResult: 'Tur Sonuçları',
      multiDuelsSummary: 'Eşzamanlı {{count}} düello tamamlandı ({{wins}} galibiyet)',
      singleDuelSummary: '{{symbol}} • {{position}}',
      netProfitLoss: 'Toplam Net K/Z',
      entryPrice: 'Giriş Fiyatı',
      closePrice: 'Kapanış Fiyatı',
      continue: 'Devam Et',

      inviteTitle: 'Özel Davet Kodu',
      inviteDesc: 'Tahmin sistemine erişim yalnızca bir davet kodu ile mümkündür. Lütfen kodunuzu girin.',
      invitePlaceholder: 'ör. REF1234',
      enterApp: 'Uygulamaya Gir',

      errSelectDirection: 'Lütfen bir yön seçin (Yukarı veya Aşağı).',
      errInvalidAmount: 'Bahis miktarı sıfırdan büyük olmalıdır.',
      errLowBalance: 'Yetersiz hesap bakiyesi!',
      errRoundFrozen: 'Tur son 30 saniye için dondurulmuştur.',
      errNoRound: 'Bu sembol için aktif tur bulunamadı.',
      errBetFailed: 'Bahis koyma başarısız oldu',
      betSuccess: 'İşlem başarıyla gerçekleştirildi!',
      errProfileFetch: 'Kullanıcı profili alınırken hata oluştu',
      errNoActiveRound: '{{symbol}} için aktif tur bulunamadı',
      errUserNotFound: 'Kullanıcı detayları bulunamadı. Lütfen tekrar giriş yapın.',

      tasksAndRewards: 'Görevler ve Ödüller',
      completeTasksDescription: 'Extra COIN kazanmak için görevleri tamamlayın!',
      daily: 'Günlük',
      weekly: 'Haftalık',
      monthly: 'Aylık',
      oneTime: 'Tek Seferlik',
      loading: 'Görevler yükleniyor...',
      noTasksAvailable: 'Bu bölümde görev bulunmamaktadır.',
      progress: 'İlerleme',
      claimed: 'Alındı',
      claim: 'Ödülü Al',
      inProgress: 'Devam Ediyor',
    },
  },
  hi: {
    translation: {
      task_daily_checkin_title: 'दैनिक उपस्थिति',
      task_daily_checkin_desc: 'अपना पुरस्कार पाने के लिए ऐप में रोजाना लॉग इन करें',
      task_first_trade_title: 'दिन का पहला ट्रेड',
      task_first_trade_desc: 'आज ही अपना पहला ट्रेड अनुमान लगाएं',
      task_active_trader_title: 'सक्रिय ट्रेडर (5 ट्रेड)',
      task_active_trader_desc: 'एक ही दिन में 5 ट्रेड पूरे करें',
      task_trading_master_title: 'ट्रेडिंग मास्टर (10 ट्रेड)',
      task_trading_master_desc: 'एक ही दिन में 10 ट्रेड पूरे करें',
      task_coin_explorer_title: 'कॉइन राउंड एक्सप्लोरर',
      task_coin_explorer_desc: '3 कॉइन-करेंसी राउंड में भाग लें',
      task_daily_victor_title: 'दैनिक विजेता',
      task_daily_victor_desc: 'आज 2 ट्रेडिंग राउंड जीतें',
      task_weekly_volume_title: 'साप्ताहिक वॉल्यूम (50 ट्रेड)',
      task_weekly_volume_desc: 'एक सप्ताह के भीतर 50 ट्रेड पूरे करें',
      task_streak_builder_title: 'जीत की लकीर (3 की स्ट्राइक)',
      task_streak_builder_desc: 'एक सप्ताह में लगातार 3 जीत हासिल करें',
      task_asset_explorer_title: 'एसेट एक्सप्लोरर',
      task_asset_explorer_desc: 'इस सप्ताह 3 अलग-अलग संपत्तियों में ट्रेड करें',
      task_high_roller_title: 'हाई रोलर',
      task_high_roller_desc: 'इस सप्ताह 5 उच्च-मूल्य वाले ट्रेड लगाएं',
      task_monthly_volume_title: 'मासिक वॉल्यूम (200 ट्रेड)',
      task_monthly_volume_desc: 'एक महीने के भीतर 200 ट्रेड पूरे करें',
      task_monthly_champion_title: 'मासिक चैंपियन (20 जीत)',
      task_monthly_champion_desc: 'इस महीने 20 ट्रेडिंग राउंड जीतें',
      task_monthly_referral_title: 'मासिक रेफरल चुनौती',
      task_monthly_referral_desc: 'इस महीने 5 नए दोस्तों को आमंत्रित करें',
      task_dedicated_trader_title: 'समर्पित ट्रेडर (15 दिन)',
      task_dedicated_trader_desc: 'इस महीने 15 अलग-अलग दिनों में ट्रेड करें',
      task_first_victory_title: 'पहली जीत',
      task_first_victory_desc: 'अपना पहला ट्रेडिंग राउंड जीतें',
      task_first_friend_title: 'पहला दोस्त आमंत्रित',
      task_first_friend_desc: 'अपने रेफरल लिंक का उपयोग करके 1 मित्र को आमंत्रित करें',
      task_squad_builder_title: 'टीम बिल्डर (5 मित्र)',
      task_squad_builder_desc: 'सफलतापूर्वक 5 दोस्तों को आमंत्रित करें',
      task_network_master_title: 'नेटवर्क मास्टर (20 मित्र)',
      task_network_master_desc: 'सफलतापूर्वक 20 दोस्तों को आमंत्रित करें',
      task_hot_streak_title: 'हॉट स्ट्राइक (5 जीत)',
      task_hot_streak_desc: 'लगातार 5 जीत की स्ट्राइक हासिल करें',
      task_unstoppable_title: 'अजेय (10 जीत)',
      task_unstoppable_desc: 'शानदार 10-जीत की स्ट्राइक हासिल करें',
      task_centurion_title: 'सेंचुरियन (100 ट्रेड)',
      task_centurion_desc: 'कुल 100 पूरे किए गए ट्रेडों तक पहुंचें',
      task_join_telegram_title: 'टेलीग्राम चैनल से जुड़ें',
      task_join_telegram_desc: 'हमारे आधिकारिक टेलीग्राम चैनल को सब्सक्राइब करें',
      task_follow_x_title: 'X (ट्विटर) पर फॉलो करें',
      task_follow_x_desc: 'हमारे आधिकारिक X (ट्विटर) अकाउंट को फॉलो करें',

      up: '▲ ऊपर',
      down: '▼ नीचे',
      startDuel: 'द्वंद्व शुरू करें',
      processing: 'प्रसंस्करण जारी है...',
      locked: 'लॉक है',
      insufficientBalance: 'अपर्याप्त शेष राशि',
      amount: 'राशि (USDT)',
      balance: 'शेष राशि',
      wins: 'जीत',
      streak: 'स्ट्राइक',
      target: 'लक्ष्य मूल्य',
      frozen: 'फ्रीज है',
      locked30s: '30 सेकंड लॉक',
      waiting: 'शुरू होने का इंतजार',
      guessText: 'अनुमान लगाएं कि क्या कीमत लक्ष्य से ऊपर रहेगी',
      trade: 'ट्रेड',
      profile: 'प्रोफ़ाइल',
      referral: 'रेफरल',
      deposit: 'जमा करें',
      withdraw: 'निकासी',
      wallet: 'वॉलेट कनेक्ट करें',
      walletAddress: 'वॉलेट पता',
      disconnect: 'डिस्कनेक्ट करें',
      depositDesc: 'अपने खाते के पते पर TON / USDT स्थानांतरित करें',
      amountToDeposit: 'जमा राशि (USDT / TON)',
      sendTransaction: 'TON वॉलेट के माध्यम से भुगतान करें',
      refDesc: 'दोस्तों को आमंत्रित करें और उनके हर ट्रेड की हमारी शुल्क आय का 30% कमाएं!',
      yourCode: 'आपका कोड',
      copy: 'कॉपी करें',
      copied: 'कॉपी हो गया',
      selected: 'चुना गया',
      pool: 'पूल',
      share: 'शेयर करें',
      shareMessage: 'CandleDuel में शामिल हों और क्रिप्टो मूल्य भविष्यवाणियों में मुकाबला करें! 🚀',

      youWon: 'आप जीत गए!',
      roundsResult: 'राउंड का परिणाम',
      multiDuelsSummary: 'एक साथ {{count}} द्वंद्व समाप्त ({{wins}} जीत)',
      singleDuelSummary: '{{symbol}} • {{position}}',
      netProfitLoss: 'कुल शुद्ध लाभ/हानि',
      entryPrice: 'प्रवेश मूल्य',
      closePrice: 'अंतिम मूल्य',
      continue: 'जारी रखें',

      inviteTitle: 'विशेष आमंत्रण कोड',
      inviteDesc: 'भविष्यवाणी प्रणाली तक पहुंच केवल एक आमंत्रण कोड के माध्यम से संभव है। कृपया अपना कोड दर्ज करें।',
      invitePlaceholder: 'जैसे REF1234',
      enterApp: 'ऐप में प्रवेश करें',

      errSelectDirection: 'कृपया दिशा (ऊपर या नीचे) चुनें।',
      errInvalidAmount: 'दांव की राशि शून्य से अधिक होनी चाहिए।',
      errLowBalance: 'खाते में अपर्याप्त शेष राशि!',
      errRoundFrozen: 'अंतिम 30 सेकंड के लिए राउंड फ्रीज है।',
      errNoRound: 'इस सिंबल के लिए कोई सक्रिय राउंड नहीं मिला।',
      errBetFailed: 'दांव लगाना असफल रहा',
      betSuccess: 'लेनदेन सफलतापूर्वक निष्पादित हुआ!',
      errProfileFetch: 'उपयोगकर्ता प्रोफ़ाइल प्राप्त करने में त्रुटि',
      errNoActiveRound: '{{symbol}} के लिए कोई सक्रिय राउंड नहीं मिला',
      errUserNotFound: 'उपयोगकर्ता विवरण नहीं मिला। कृपया पुनः लॉगिन करें।',

      tasksAndRewards: 'कार्य और पुरस्कार',
      completeTasksDescription: 'अतिरिक्त सिक्के कमाने के लिए कार्य पूरे करें!',
      daily: 'दैनिक',
      weekly: 'साप्ताहिक',
      monthly: 'मासिक',
      oneTime: 'एक बार',
      loading: 'कार्य लोड हो रहे हैं...',
      noTasksAvailable: 'इस अनुभाग में कोई कार्य उपलब्ध नहीं है।',
      progress: 'प्रगति',
      claimed: 'दावा किया गया',
      claim: 'दावा करें',
      inProgress: 'प्रगति पर है',
    },
  },
  fa: {
    translation: {
      task_daily_checkin_title: 'ورود روزانه',
      task_daily_checkin_desc: 'هر روز وارد برنامه شوید تا پاداش خود را دریافت کنید',
      task_first_trade_title: 'اولین معامله روز',
      task_first_trade_desc: 'امروز اولین پیش‌بینی معامله خود را ثبت کنید',
      task_active_trader_title: 'معامله‌گر فعال (۵ معامله)',
      task_active_trader_desc: 'در یک روز ۵ معامله انجام دهید',
      task_trading_master_title: 'استاد معامله‌گری (۱۰ معامله)',
      task_trading_master_desc: 'در یک روز ۱۰ معامله انجام دهید',
      task_coin_explorer_title: 'کاشف راند کریپتو',
      task_coin_explorer_desc: 'در ۳ راند ارز دیجیتال شرکت کنید',
      task_daily_victor_title: 'برنده روزانه',
      task_daily_victor_desc: 'امروز در ۲ راند معامله برنده شوید',
      task_weekly_volume_title: 'حجم هفتگی (۵۰ معامله)',
      task_weekly_volume_desc: 'ظرف یک هفته ۵۰ معامله انجام دهید',
      task_streak_builder_title: 'سازنده برد متوالی (۳ برد)',
      task_streak_builder_desc: 'در طول یک هفته به ۳ برد متوالی برسید',
      task_asset_explorer_title: 'کاشف بازارها',
      task_asset_explorer_desc: 'این هفته در ۳ بازار مختلف معامله کنید',
      task_high_roller_title: 'معامله‌گر بزرگ',
      task_high_roller_desc: 'این هفته ۵ معامله با ارزش بالا ثبت کنید',
      task_monthly_volume_title: 'حجم ماهانه (۲۰۰ معامله)',
      task_monthly_volume_desc: 'ظرف یک ماه ۲۰۰ معامله انجام دهید',
      task_monthly_champion_title: 'قهرمان ماهانه (۲۰ برد)',
      task_monthly_champion_desc: 'این ماه در ۲۰ راند معامله پیروز شوید',
      task_monthly_referral_title: 'چالش دعوت ماهانه',
      task_monthly_referral_desc: 'این ماه ۵ دوست جدید دعوت کنید',
      task_dedicated_trader_title: 'معامله‌گر وفادار (۱۵ روز)',
      task_dedicated_trader_desc: 'در ۱۵ روز مختلف این ماه معامله کنید',
      task_first_victory_title: 'اولین پیروزی',
      task_first_victory_desc: 'در اولین راند معامله خود برنده شوید',
      task_first_friend_title: 'اولین دوست دعوت شده',
      task_first_friend_desc: '۱ دوست را با لینک اختصاصی خود دعوت کنید',
      task_squad_builder_title: 'تیم‌ساز (۵ دوست)',
      task_squad_builder_desc: 'با موفقیت ۵ دوست را دعوت کنید',
      task_network_master_title: 'استاد شبکه‌سازی (۲۰ دوست)',
      task_network_master_desc: 'با موفقیت ۲۰ دوست را دعوت کنید',
      task_hot_streak_title: 'موج برد (۵ برد متوالی)',
      task_hot_streak_desc: 'به ۵ برد متوالی دست پیدا کنید',
      task_unstoppable_title: 'توقف‌ناپذیر (۱۰ برد متوالی)',
      task_unstoppable_desc: 'به ۱۰ برد متوالی شاهکار دست پیدا کنید',
      task_centurion_title: 'سنتوریون (۱۰۰ معامله)',
      task_centurion_desc: 'در مجموع به ۱۰۰ معامله انجام‌شده برسید',
      task_join_telegram_title: 'عضویت در کانال تلگرام',
      task_join_telegram_desc: 'عضو کانال رسمی تلگرام ما شوید',
      task_follow_x_title: 'دنبال کردن در X (توییتر)',
      task_follow_x_desc: 'صفحه رسمی X (توییتر) ما را دنبال کنید',

      up: '▲ بالا',
      down: '▼ پایین',
      startDuel: 'شروع دوئل',
      processing: 'در حال پردازش...',
      locked: 'قفل شده',
      insufficientBalance: 'موجودی کافی نیست',
      amount: 'مبلغ (تتر)',
      balance: 'موجودی',
      wins: 'برد',
      streak: 'زنجیره',
      target: 'قیمت هدف',
      frozen: 'منجمد',
      locked30s: '۳۰ ثانیه قفل',
      waiting: 'در انتظار شروع',
      guessText: 'پیش‌بینی کنید آیا قیمت بالاتر از هدف می‌ماند یا خیر',
      trade: 'معامله',
      profile: 'پروفایل',
      referral: 'زیرمجموعه',
      deposit: 'واریز',
      withdraw: 'برداشت',
      wallet: 'اتصال ولت',
      walletAddress: 'آدرس ولت',
      disconnect: 'قطع اتصال',
      depositDesc: 'مبلغ مورد نظر را به آدرس ولت زیر واریز کنید',
      amountToDeposit: 'مبلغ واریزی',
      sendTransaction: 'پرداخت با ولت تلگرام',
      refDesc: 'دوستان خود را دعوت کنید و ۵٪ از کارمزد تمام معاملات آن‌ها را دریافت کنید!',
      yourCode: 'کد شما',
      copy: 'کپی',
      copied: 'کپی شد',
      selected: 'انتخاب شد',
      pool: 'استخر',
      share: 'ارسال',
      shareMessage: 'به CandleDuel بپیوندید و در پیش‌بینی قیمت کریپتو با بقیه رقابت کنید! 🚀',

      youWon: 'شما بردید!',
      roundsResult: 'نتیجه راندها',
      multiDuelsSummary: 'پایان {{count}} دوئل هم‌زمان ({{wins}} برد)',
      singleDuelSummary: '{{symbol}} • {{position}}',
      netProfitLoss: 'مجموع سود/زیان خالص',
      entryPrice: 'قیمت ورود',
      closePrice: 'قیمت بسته شدن',
      continue: 'ادامه',

      inviteTitle: 'کد دعوت اختصاصی',
      inviteDesc: 'ورود به سیستم پیش‌بینی فقط با داشتن کد دعوت امکان‌پذیر است. لطفاً کد دعوت خود را وارد کنید.',
      invitePlaceholder: 'مثلاً: REF1234',
      enterApp: 'ورود به برنامه',

      errSelectDirection: 'لطفاً جهت حرکت قیمت (بالا یا پایین) را انتخاب کنید.',
      errInvalidAmount: 'مبلغ شرط باید بیشتر از صفر باشد.',
      errLowBalance: 'موجودی حساب شما کافی نیست!',
      errRoundFrozen: 'راند در ۳۰ ثانیه پایانی قرار دارد و امکان ثبت شرط وجود ندارد.',
      errNoRound: 'راند فعالی برای این نماد یافت نشد.',
      errBetFailed: 'خطا در ثبت پوزیشن',
      betSuccess: 'تراکنش با موفقیت انجام شد!',
      errProfileFetch: 'خطا در دریافت پروفایل کاربر',
      errNoActiveRound: 'راند فعالی برای {{symbol}} یافت نشد',
      errUserNotFound: 'اطلاعات کاربر یافت نشد. لطفاً مجدداً وارد شوید.',

      tasksAndRewards: 'ماموریت‌ها و پاداش‌ها',
      completeTasksDescription: 'ماموریت‌ها را کامل کنید تا سکه اضافی بگیرید!',
      daily: 'روزانه',
      weekly: 'هفتگی',
      monthly: 'ماهانه',
      oneTime: 'یک‌باره',
      loading: 'در حال بارگذاری ماموریت‌ها...',
      noTasksAvailable: 'هیچ ماموریتی در این بخش وجود ندارد.',
      progress: 'پیشرفت',
      claimed: 'دریافت شده',
      claim: 'دریافت پاداش',
      inProgress: 'در حال انجام',
    },
  },
  ar: {
    translation: {
      task_daily_checkin_title: 'تسجيل الدخول اليومي',
      task_daily_checkin_desc: 'سجل الدخول إلى التطبيق يوميًا للمطالبة بمكافأتك',
      task_first_trade_title: 'الصفقة الأولى في اليوم',
      task_first_trade_desc: 'قم بوضع توقعك الأول للتداول اليوم',
      task_active_trader_title: 'متداول نشط (٥ صفقات)',
      task_active_trader_desc: 'أكمل ٥ صفقات في يوم واحد',
      task_trading_master_title: 'خبير التداول (١٠ صفقات)',
      task_trading_master_desc: 'أكمل ١٠ صفقات في يوم واحد',
      task_coin_explorer_title: 'مستكشف جولات العملات',
      task_coin_explorer_desc: 'شارك في ٣ جولات تداول للعملات',
      task_daily_victor_title: 'الفائز اليومي',
      task_daily_victor_desc: 'افز بجولتي تداول اليوم',
      task_weekly_volume_title: 'الحجم الأسبوعي (٥٠ صفقة)',
      task_weekly_volume_desc: 'أكمل ٥٠ صفقة خلال أسبوع',
      task_streak_builder_title: 'باني الانتصارات (٣ انتصارات متتالية)',
      task_streak_builder_desc: 'حقق سلسلة ٣ انتصارات متتالية في الأسبوع',
      task_asset_explorer_title: 'مستكشف الأسواق',
      task_asset_explorer_desc: 'تداول في ٣ أسواق مختلفة للأصول هذا الأسبوع',
      task_high_roller_title: 'المتداول الكبير',
      task_high_roller_desc: 'قم بوضع ٥ صفقات عالية القيمة هذا الأسبوع',
      task_monthly_volume_title: 'الحجم الشهري (٢٠٠ صفقة)',
      task_monthly_volume_desc: 'أكمل ٢٠٠ صفقة خلال شهر',
      task_monthly_champion_title: 'بطل الشهر (٢٠ انتصارًا)',
      task_monthly_champion_desc: 'افز بـ ٢٠ جولة تداول هذا الشهر',
      task_monthly_referral_title: 'تحدي الإحالة الشهري',
      task_monthly_referral_desc: 'ادعُ ٥ أصدقاء جدد هذا الشهر',
      task_dedicated_trader_title: 'متداول مخلص (١٥ يومًا)',
      task_dedicated_trader_desc: 'تداول في ١٥ يومًا مختلفًا هذا الشهر',
      task_first_victory_title: 'الفوز الأول',
      task_first_victory_desc: 'افز بجولتك الأولى في التداول',
      task_first_friend_title: 'أول صديق مَدعو',
      task_first_friend_desc: 'ادعُ صديقًا واحدًا باستخدام رابط الإحالة الخاص بك',
      task_squad_builder_title: 'باني الفريق (٥ أصدقاء)',
      task_squad_builder_desc: 'نجحت في دعوة ٥ أصدقاء',
      task_network_master_title: 'سيد الشبكة (٢٠ صديقًا)',
      task_network_master_desc: 'نجحت في دعوة ٢٠ صديقًا',
      task_hot_streak_title: 'سلسلة انتصارات نارية (٥ انتصارات)',
      task_hot_streak_desc: 'حقق سلسلة ٥ انتصارات متتالية',
      task_unstoppable_title: 'لا يُقهر (١٠ انتصارات)',
      task_unstoppable_desc: 'حقق سلسلة ۱۰ انتصارات متتالية ملحمية',
      task_centurion_title: 'المئوي (١٠٠ صفقة)',
      task_centurion_desc: 'صل إلى إجمالي ١٠٠ صفقة مكتملة',
      task_join_telegram_title: 'الانضمام لقناة تلغرام',
      task_join_telegram_desc: 'اشترك في قناتنا الرسمية على تلغرام',
      task_follow_x_title: 'متابعة على X (تويتر)',
      task_follow_x_desc: 'تابع حسابنا الرسمي على منصة X (تويتر)',

      up: '▲ صعود',
      down: '▼ هبوط',
      startDuel: 'بدء المواجهة',
      processing: 'جاري المعالجة...',
      locked: 'مغلق',
      insufficientBalance: 'رصيد غير كافٍ',
      amount: 'المبلغ (USDT)',
      balance: 'الرصيد',
      wins: 'انتصارات',
      streak: 'سلسلة',
      target: 'الهدف',
      frozen: 'مجمّد',
      locked30s: 'مغلق ٣٠ ثانية',
      waiting: 'في انتظار البدء',
      guessText: 'توقع ما إذا كان السعر سيبقى أعلى من الهدف',
      trade: 'تداول',
      profile: 'الملف الشخصي',
      referral: 'الإحالة',
      deposit: 'إيداع',
      withdraw: 'سحب',
      wallet: 'ربط المحفظة',
      walletAddress: 'عنوان المحفظة',
      disconnect: 'قطع الاتصال',
      depositDesc: 'قم بتحويل المبلغ إلى عنوان المحفظة أدناه',
      amountToDeposit: 'المبلغ المراد إيداعه',
      sendTransaction: 'الدفع عبر محفظة تلغرام',
      refDesc: 'ادعُ أصدقاءك واحصل على ٥٪ من رسوم جميع تداولاتها!',
      yourCode: 'رمزك',
      copy: 'نسخ',
      copied: 'تم النسخ',
      selected: 'محدد',
      pool: 'المجمع',
      share: 'مشاركة',
      shareMessage: 'انضم إلى CandleDuel وتنافس في توقعات أسعار العملات المشفرة! 🚀',

      youWon: 'لقد فزت!',
      roundsResult: 'نتيجة الجولات',
      multiDuelsSummary: 'انتهت {{count}} مواجهات متزامنة ({{wins}} انتصار)',
      singleDuelSummary: '{{symbol}} • {{position}}',
      netProfitLoss: 'إجمالي صافي الربح/الخسارة',
      entryPrice: 'سعر الدخول',
      closePrice: 'سعر الإغلاق',
      continue: 'متابعة',

      inviteTitle: 'رمز الدعوة الحصري',
      inviteDesc: 'الدخول إلى نظام التوقعات متاح فقط باستخدام رمز الدعوة. يرجى إدخال الرمز الخاص بك.',
      invitePlaceholder: 'مثال: REF1234',
      enterApp: 'الدخول إلى التطبيق',

      errSelectDirection: 'يرجى اختيار اتجاه الحركة (صعود أم هبوط).',
      errInvalidAmount: 'يجب أن يكون مبلغ الرهان أكبر من الصفر.',
      errLowBalance: 'رصيد حسابك غير كافٍ!',
      errRoundFrozen: 'الجولة مجمّدة في آخر ٣٠ ثانية ولا يمكن الرهان.',
      errNoRound: 'لم يتم العثور على جولة نشطة لهذا الرمز.',
      errBetFailed: 'فشل في تسجيل الرهان',
      betSuccess: 'تمت العملية بنجاح!',
      errProfileFetch: 'خطأ في جلب الملف الشخصي للمستخدم',
      errNoActiveRound: 'لم يتم العثور على جولة نشطة لـ {{symbol}}',
      errUserNotFound: 'لم يتم العثور على تفاصيل المستخدم. يرجى تسجيل الدخول مرة أخرى.',

      tasksAndRewards: 'المهام والمكافآت',
      completeTasksDescription: 'أكمل المهام لكسب عملات إضافية!',
      daily: 'يومي',
      weekly: 'أسبوعي',
      monthly: 'شهري',
      oneTime: 'مرة واحدة',
      loading: 'جاري تحميل المهام...',
      noTasksAvailable: 'لا توجد مهام متاحة في هذا القسم.',
      progress: 'التقدم',
      claimed: 'تم الاستلام',
      claim: 'مطالبة',
      inProgress: 'قيد التقدم',
    },
  },
  ru: {
    translation: {
      task_daily_checkin_title: 'Ежедневный вход',
      task_daily_checkin_desc: 'Заходите в приложение каждый день, чтобы забрать награду',
      task_first_trade_title: 'Первая сделка дня',
      task_first_trade_desc: 'Сделайте ваш первый прогноз сегодня',
      task_active_trader_title: 'Активный трейдер (5 сделок)',
      task_active_trader_desc: 'Завершите 5 сделок за один день',
      task_trading_master_title: 'Мастер торговли (10 сделок)',
      task_trading_master_desc: 'Завершите 10 сделок за один день',
      task_coin_explorer_title: 'Исследователь крипто-раундов',
      task_coin_explorer_desc: 'Примите участие в 3 крипто-раундах',
      task_daily_victor_title: 'Дневной победитель',
      task_daily_victor_desc: 'Выиграйте 2 торговых раунда сегодня',
      task_weekly_volume_title: 'Недельный объем (50 сделок)',
      task_weekly_volume_desc: 'Завершите 50 сделок за неделю',
      task_streak_builder_title: 'Серия побед (3 победы)',
      task_streak_builder_desc: 'Достигните серии из 3 побед за неделю',
      task_asset_explorer_title: 'Исследователь рынков',
      task_asset_explorer_desc: 'Совершайте сделки на 3 разных рынках активов на этой неделе',
      task_high_roller_title: 'Крупный игрок',
      task_high_roller_desc: 'Сделайте 5 крупных сделок на этой неделе',
      task_monthly_volume_title: 'Месячный объем (200 сделок)',
      task_monthly_volume_desc: 'Завершите 200 сделок за месяц',
      task_monthly_champion_title: 'Чемпион месяца (20 побед)',
      task_monthly_champion_desc: 'Выиграйте 20 торговых раундов в этом месяце',
      task_monthly_referral_title: 'Ежемесячный реферальный челлендж',
      task_monthly_referral_desc: 'Пригласите 5 новых друзей в этом месяце',
      task_dedicated_trader_title: 'Преданный трейдер (15 дней)',
      task_dedicated_trader_desc: 'Торгуйте 15 разных дней в этом месяце',
      task_first_victory_title: 'Первая победа',
      task_first_victory_desc: 'Выиграйте свой самый первый торговый раунд',
      task_first_friend_title: 'Первый приглашенный друг',
      task_first_friend_desc: 'Пригласите 1 друга по своей реферальной ссылке',
      task_squad_builder_title: 'Создатель команды (5 друзей)',
      task_squad_builder_desc: 'Успешно пригласите 5 друзей',
      task_network_master_title: 'Мастер сети (20 друзей)',
      task_network_master_desc: 'Успешно пригласите 20 друзей',
      task_hot_streak_title: 'Горячая серия (5 побед)',
      task_hot_streak_desc: 'Достигните серии из 5 побед подряд',
      task_unstoppable_title: 'Неудержимый (10 побед)',
      task_unstoppable_desc: 'Достигните эпической серии из 10 побед подряд',
      task_centurion_title: 'Центурион (100 сделок)',
      task_centurion_desc: 'Достигните 100 завершенных сделок',
      task_join_telegram_title: 'Вступить в Telegram-канал',
      task_join_telegram_desc: 'Подпишитесь на наш официальный Telegram-канал',
      task_follow_x_title: 'Читать в X (Twitter)',
      task_follow_x_desc: 'Подпишитесь на наш официальный аккаунт в X (Twitter)',

      up: '▲ Вверх',
      down: '▼ Вниз',
      startDuel: 'Начать дуэль',
      processing: 'Обработка...',
      locked: 'Заблокировано',
      insufficientBalance: 'Недостаточно средств',
      amount: 'Сумма (USDT)',
      balance: 'Баланс',
      wins: 'побед',
      streak: 'Серия',
      target: 'Цель',
      frozen: 'ЗАМОРОЖЕНО',
      locked30s: '30с БЛОКИРОВКА',
      waiting: 'Ожидание старта',
      guessText: 'Угадайте, останется ли цена выше цели',
      trade: 'Торги',
      profile: 'Профиль',
      referral: 'Рефералы',
      deposit: 'Депозит',
      withdraw: 'Вывод',
      wallet: 'Подключить кошелек',
      walletAddress: 'Адрес кошелька',
      disconnect: 'Отключить',
      depositDesc: 'Переведите TON / USDT на указанный адрес',
      amountToDeposit: 'Сумма депозита',
      sendTransaction: 'Оплатить через Telegram Wallet',
      refDesc: 'Приглашайте друзей и получайте 30% от наших комиссий с каждой сделки!',
      yourCode: 'Ваш код',
      copy: 'Копировать',
      copied: 'Скопировано',
      selected: 'Выбрано',
      pool: 'Пул',
      share: 'Поделиться',
      shareMessage: 'Присоединяйтесь к CandleDuel и соревнуйтесь в прогнозировании цен на криптовалюту! 🚀',

      youWon: 'Вы выиграли!',
      roundsResult: 'Результат раундов',
      multiDuelsSummary: 'Завершено {{count}} одновременных дуэлей (побед: {{wins}})',
      singleDuelSummary: '{{symbol}} • {{position}}',
      netProfitLoss: 'Общий чистый P&L',
      entryPrice: 'Цена входа',
      closePrice: 'Цена закрытия',
      continue: 'Продолжить',

      inviteTitle: 'Эксклюзивный инвайт-код',
      inviteDesc: 'Доступ к системе прогнозирования возможен только по инвайт-коду. Пожалуйста, введите ваш код.',
      invitePlaceholder: 'Например: REF1234',
      enterApp: 'Войти в приложение',

      errSelectDirection: 'Пожалуйста, выберите направление (Вверх или Вниз).',
      errInvalidAmount: 'Сумма ставки должна быть больше нуля.',
      errLowBalance: 'Недостаточно средств на счете!',
      errRoundFrozen: 'Раунд заморожен на последние 30 секунд.',
      errNoRound: 'Активный раунд для этого символа не найден.',
      errBetFailed: 'Ошибка размещения ставки',
      betSuccess: 'Транзакция успешно выполнена!',
      errProfileFetch: 'Ошибка получения профиля пользователя',
      errNoActiveRound: 'Активный раунд для {{symbol}} не найден',
      errUserNotFound: 'Данные пользователя не найдены. Пожалуйста, войдите снова.',

      tasksAndRewards: 'Задания и Награды',
      completeTasksDescription: 'Выполняйте задания, чтобы заработать дополнительные монеты!',
      daily: 'Ежедневно',
      weekly: 'Еженедельно',
      monthly: 'Ежемесячно',
      oneTime: 'Разовые',
      loading: 'Загрузка заданий...',
      noTasksAvailable: 'В этом разделе нет доступных заданий.',
      progress: 'Прогресс',
      claimed: 'Получено',
      claim: 'Забрать',
      inProgress: 'В процессе',
    },
  },
  es: {
    translation: {
      task_daily_checkin_title: 'Registro Diario',
      task_daily_checkin_desc: 'Inicia sesión diariamente en la aplicación para reclamar tu recompensa',
      task_first_trade_title: 'Primera Operación del Día',
      task_first_trade_desc: 'Realiza tu primera predicción del día',
      task_active_trader_title: 'Trader Activo (5 Operaciones)',
      task_active_trader_desc: 'Completa 5 operaciones en un solo día',
      task_trading_master_title: 'Maestro del Trading (10 Operaciones)',
      task_trading_master_desc: 'Completa 10 operaciones en un solo día',
      task_coin_explorer_title: 'Explorador de Rondas Cripto',
      task_coin_explorer_desc: 'Participa en 3 rondas de criptomonedas',
      task_daily_victor_title: 'Ganador Diario',
      task_daily_victor_desc: 'Gana 2 rondas de operaciones hoy',
      task_weekly_volume_title: 'Volumen Semanal (50 Operaciones)',
      task_weekly_volume_desc: 'Completa 50 operaciones en una semana',
      task_streak_builder_title: 'Creador de Rachas (3 Seguidas)',
      task_streak_builder_desc: 'Alcanza una racha de 3 victorias en una semana',
      task_asset_explorer_title: 'Explorador de Mercados',
      task_asset_explorer_desc: 'Opera en 3 mercados de activos diferentes esta semana',
      task_high_roller_title: 'Gran Apostador',
      task_high_roller_desc: 'Realiza 5 operaciones de alto valor esta semana',
      task_monthly_volume_title: 'Volumen Mensual (200 Operaciones)',
      task_monthly_volume_desc: 'Completa 200 operaciones en un mes',
      task_monthly_champion_title: 'Campeón Mensual (20 Victorias)',
      task_monthly_champion_desc: 'Gana 20 rondas de operaciones este mes',
      task_monthly_referral_title: 'Desafío de Referidos Mensual',
      task_monthly_referral_desc: 'Invita a 5 nuevos amigos este mes',
      task_dedicated_trader_title: 'Trader Dedicado (15 Días)',
      task_dedicated_trader_desc: 'Opera en 15 días diferentes este mes',
      task_first_victory_title: 'Primera Victoria',
      task_first_victory_desc: 'Gana tu primera ronda de operaciones',
      task_first_friend_title: 'Primer Amigo Invitado',
      task_first_friend_desc: 'Invita a 1 amigo usando tu enlace de referido',
      task_squad_builder_title: 'Creador de Escuadrón (5 Amigos)',
      task_squad_builder_desc: 'Invita con éxito a 5 amigos',
      task_network_master_title: 'Maestro de la Red (20 Amigos)',
      task_network_master_desc: 'Invita con éxito a 20 amigos',
      task_hot_streak_title: 'Racha Enrachada (5 Victorias)',
      task_hot_streak_desc: 'Consigue una racha de 5 victorias consecutivas',
      task_unstoppable_title: 'Imparable (10 Victorias)',
      task_unstoppable_desc: 'Consigue una racha épica de 10 victorias consecutivas',
      task_centurion_title: 'Centurión (100 Operaciones)',
      task_centurion_desc: 'Alcanza un total de 100 operaciones completadas',
      task_join_telegram_title: 'Unirse al Canal de Telegram',
      task_join_telegram_desc: 'Suscríbete a nuestro canal oficial de Telegram',
      task_follow_x_title: 'Seguir en X (Twitter)',
      task_follow_x_desc: 'Sigue nuestra cuenta oficial de X (Twitter)',

      up: '▲ Arriba',
      down: '▼ Abajo',
      startDuel: 'Iniciar duelo',
      processing: 'Procesando...',
      locked: 'Bloqueado',
      insufficientBalance: 'Saldo insuficiente',
      amount: 'Monto (USDT)',
      balance: 'Saldo',
      wins: 'victorias',
      streak: 'Racha',
      target: 'Objetivo',
      frozen: 'CONGELADO',
      locked30s: '30s BLOQUEADO',
      waiting: 'Esperando inicio',
      guessText: 'Adivina si el precio se mantiene arriba',
      trade: 'Trazar',
      profile: 'Perfil',
      referral: 'Referidos',
      deposit: 'Depositar',
      withdraw: 'Retirar',
      wallet: 'Conectar Wallet',
      walletAddress: 'Dirección de Wallet',
      disconnect: 'Desconectar',
      depositDesc: 'Transfiere TON / USDT a la siguiente dirección',
      amountToDeposit: 'Monto a depositar',
      sendTransaction: 'Pagar con Wallet de Telegram',
      refDesc: '¡Invita amigos y gana el 30% de nuestras comisiones en cada operación!',
      yourCode: 'Tu Código',
      copy: 'Copiar',
      copied: 'Copiado',
      selected: 'Seleccionado',
      pool: 'Fondo',
      share: 'Compartir',
      shareMessage: '¡Únete a CandleDuel y compite en predicciones de precios de criptomonedas! 🚀',

      youWon: '¡Ganaste!',
      roundsResult: 'Resultado de rondas',
      multiDuelsSummary: 'Finalizados {{count}} duelos simultáneos ({{wins}} victorias)',
      singleDuelSummary: '{{symbol}} • {{position}}',
      netProfitLoss: 'P&L neto total',
      entryPrice: 'Precio de entrada',
      closePrice: 'Precio de cierre',
      continue: 'Continuar',

      inviteTitle: 'Código de invitación exclusivo',
      inviteDesc: 'El acceso al sistema de predicción solo es posible con un código de invitación. Por favor, introduce tu código.',
      invitePlaceholder: 'ej. REF1234',
      enterApp: 'Entrar a la aplicación',

      errSelectDirection: 'Por favor selecciona una dirección (Arriba o Abajo).',
      errInvalidAmount: 'El monto debe ser mayor a cero.',
      errLowBalance: '¡Saldo insuficiente!',
      errRoundFrozen: 'Ronda congelada en los últimos 30 segundos.',
      errNoRound: 'No hay ronda activa para este símbolo.',
      errBetFailed: 'Error al realizar la apuesta',
      betSuccess: '¡Transacción realizada con éxito!',
      errProfileFetch: 'Error al obtener el perfil de usuario',
      errNoActiveRound: 'No se encontró una ronda activa para {{symbol}}',
      errUserNotFound: 'Detalles de usuario no encontrados. Por favor inicia sesión de nuevo.',

      tasksAndRewards: 'Tareas y Recompensas',
      completeTasksDescription: '¡Completa tareas para ganar monedas extra!',
      daily: 'Diario',
      weekly: 'Semanal',
      monthly: 'Mensual',
      oneTime: 'Una vez',
      loading: 'Cargando tareas...',
      noTasksAvailable: 'No hay tareas disponibles en esta sección.',
      progress: 'Progreso',
      claimed: 'Reclamado',
      claim: 'Reclamar',
      inProgress: 'En progreso',
    },
  },
  zh: {
    translation: {
      task_daily_checkin_title: '每日签到',
      task_daily_checkin_desc: '每天登录应用以领取奖励',
      task_first_trade_title: '每日首交易',
      task_first_trade_desc: '今天提交你的第一次交易预测',
      task_active_trader_title: '活跃交易者（5次交易）',
      task_active_trader_desc: '一天内完成 5 次交易',
      task_trading_master_title: '交易大师（10次交易）',
      task_trading_master_desc: '一天内完成 10 次交易',
      task_coin_explorer_title: '加密轮次探索者',
      task_coin_explorer_desc: '参与 3 次加密货币交易轮次',
      task_daily_victor_title: '每日胜者',
      task_daily_victor_desc: '今天赢得 2 轮交易',
      task_weekly_volume_title: '每周交易量（50次交易）',
      task_weekly_volume_desc: '一周内完成 50 次交易',
      task_streak_builder_title: '连胜构造者（3连胜）',
      task_streak_builder_desc: '在一周内达到 3 连胜',
      task_asset_explorer_title: '市场探索者',
      task_asset_explorer_desc: '本周在 3 个不同的资产市场进行交易',
      task_high_roller_title: '高额交易者',
      task_high_roller_desc: '本周进行 5 次高价值交易',
      task_monthly_volume_title: '每月交易量（200次交易）',
      task_monthly_volume_desc: '一个月内完成 200 次交易',
      task_monthly_champion_title: '月度冠军（20胜）',
      task_monthly_champion_desc: '本月赢得 20 轮交易',
      task_monthly_referral_title: '月度邀请挑战',
      task_monthly_referral_desc: '本月邀请 5 位新朋友',
      task_dedicated_trader_title: '忠诚交易者（15天）',
      task_dedicated_trader_desc: '本月在 15 个不同的日子里进行交易',
      task_first_victory_title: '首胜',
      task_first_victory_desc: '赢得你的第一轮交易',
      task_first_friend_title: '首位邀请好友',
      task_first_friend_desc: '使用你的邀请链接邀请 1 位好友',
      task_squad_builder_title: '战队建设者（5位好友）',
      task_squad_builder_desc: '成功邀请 5 位好友',
      task_network_master_title: '网络大师（20位好友）',
      task_network_master_desc: '成功邀请 20 位好友',
      task_hot_streak_title: '火热连胜（5连胜）',
      task_hot_streak_desc: '达成连续 5 连胜',
      task_unstoppable_title: '势不可挡（10连胜）',
      task_unstoppable_desc: '达成史诗般的 10 连胜',
      task_centurion_title: '百战勇士（100次交易）',
      task_centurion_desc: '累计完成 100 次交易',
      task_join_telegram_title: '加入 Telegram 频道',
      task_join_telegram_desc: '订阅我们的官方 Telegram 频道',
      task_follow_x_title: '关注 X (Twitter)',
      task_follow_x_desc: '关注我们的官方 X (Twitter) 账号',

      up: '▲ 看涨',
      down: '▼ 看跌',
      startDuel: '开始对决',
      processing: '处理中...',
      locked: '已锁定',
      insufficientBalance: '余额不足',
      amount: '金额 (USDT)',
      balance: '余额',
      wins: '胜场',
      streak: '连胜',
      target: '目标价',
      frozen: '已冻结',
      locked30s: '30秒 锁定',
      waiting: '等待开始',
      guessText: '预测价格是否高于目标价',
      trade: '交易',
      profile: '个人中心',
      referral: '邀请',
      deposit: '充值',
      withdraw: '提现',
      wallet: '连接钱包',
      walletAddress: '钱包地址',
      disconnect: '断开连接',
      depositDesc: '转账 TON / USDT 至以下地址',
      amountToDeposit: '充值金额',
      sendTransaction: '使用 Telegram 钱包支付',
      refDesc: '邀请好友，赚取他们每笔交易手续费 30% 的奖励！',
      yourCode: '你的邀请码',
      copy: '复制',
      copied: '已复制',
      selected: '已选择',
      pool: '奖池',
      share: '分享',
      shareMessage: '加入 CandleDuel，参与加密货币价格预测对决！ 🚀',

      youWon: '你赢了！',
      roundsResult: '本轮结果',
      multiDuelsSummary: '已完成 {{count}} 场同时进行的对决（获胜 {{wins}} 场）',
      singleDuelSummary: '{{symbol}} • {{position}}',
      netProfitLoss: '累计净盈亏',
      entryPrice: '入场价',
      closePrice: '结算价',
      continue: '继续',

      inviteTitle: '专属邀请码',
      inviteDesc: '只有拥有邀请码才能进入预测系统。请输入您的邀请码。',
      invitePlaceholder: '例如: REF1234',
      enterApp: '进入应用',

      errSelectDirection: '请选择预测方向（看涨或看跌）。',
      errInvalidAmount: '下注金额必须大于零。',
      errLowBalance: '账户余额不足！',
      errRoundFrozen: '最后30秒已冻结下注。',
      errNoRound: '未找到该币种的有效轮次。',
      errBetFailed: '下注失败',
      betSuccess: '交易成功！',
      errProfileFetch: '获取用户信息失败',
      errNoActiveRound: '未找到 {{symbol}} 的有效轮次',
      errUserNotFound: '未找到用户信息，请重新登录。',

      tasksAndRewards: '任务与奖励',
      completeTasksDescription: '完成任务以赚取额外金币！',
      daily: '每日',
      weekly: '每周',
      monthly: '每月',
      oneTime: '一次性',
      loading: '加载任务中...',
      noTasksAvailable: '该板块暂无可用任务。',
      progress: '进度',
      claimed: '已领取',
      claim: '领取',
      inProgress: '进行中',
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export default i18n;